import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { v4 as uuidv4 } from 'uuid';

export interface INodoOrganigramaSeguimiento {
  nors_id: number;
  nors_norid: number;
  nors_mails: string | null;
  nors_modificado_colid?: number | null;
  nors_eliminado?: number;
  nors_eliminado_colid?: number | null;
  nors_fecha_eliminacion?: string | null;
}

export interface ResponseInset<T> {
  statusCode:   number;
  statusMsg:    string;
  statusDetail: string;
  debugInfo:    null;
  httpCode:     null;
  attributes:   null;
  data:         T;
  segment:      null;
}




export class NodoOrganigramaSeguimientoSystem {
  private readonly base = '/nodo-organigrama-seguimiento';

  constructor(private requestHandler: XhrRequestHandler) {}

  // Obtener un seguimiento por ID
  async getById(norsId: number) {
    const headers = {idtransaccion: uuidv4(), msgtransaccion: "Obtener nodo de organigrama por ID"}
    return await this.requestHandler.getheader<ResponseInset<INodoOrganigramaSeguimiento>>(`${this.base}/find-by-id/${norsId}`, headers);
  }

  // Obtener un seguimiento por el id del nodo
  async getByNodeId(nor_id: number) {
    const headers = {idtransaccion: uuidv4(), msgtransaccion: "Obtener nodo de organigrama por ID"}
    return await this.requestHandler.getheader<ResponseInset<INodoOrganigramaSeguimiento>>(`${this.base}/find-by-nodeId/${nor_id}`, headers);
  }

  // Upsert (insertar o actualizar)
  async upsert(data: Pick<INodoOrganigramaSeguimiento, 'nors_id' | 'nors_norid' | 'nors_mails'>) {
    const headers = {idtransaccion: uuidv4(), msgtransaccion: "Upsert nodo de organigrama"}
    return await this.requestHandler.postss<ResponseInset<{ nors_id: string, nors_mails: string }>>(`${this.base}/upsert`, data, headers);
  }

  // Eliminado lógico
  async softDelete(norsId: number) {
    return await this.requestHandler.delete<boolean>(`${this.base}/delete/${norsId}`);
  }
}
